module.exports = __webpack_public_path__ + "assets/img/notice.ac00e7fc.png";